/**
 * Created by Pactera on 2017/4/14.
 * 退改后详情页面
 */
import Routes from 'Routes';
import {
  saveOldLocation,
  getPassageMemberLevel,
  createNpsQnrDetail,
  searchNpsUrl,
} from '../../modules/actions';
import memberPopup from '../../../components/MemberPopup';
import PopUpLoad from 'PopUpLoad';
import { gspCollect, isCsairApp, gspNewVersion } from '@csair/emp-helpers';
import { getScheme } from './modules/actions';
import { userAgentType, session } from 'Utils';
import { loadStatusCodeMsg } from 'enEXchange';
export default store => ({
  path: Routes.ticket.child.reformProcess.key,
  async onEnter(nextState, replace, callback) {
    loadStatusCodeMsg([
      'afterSaleChangeReqDetail',
      'cancleChangePayIn',
      'afterGetRefundOrderDetail',
      'getVerificationCode',
    ]);
    const { orderType, orderNo, linkType, channel } = nextState.location.query;
    if (linkType && linkType === 'wechat') {
      let {
        payload: {
          data: { openlink, wechatAppLinkSwitch },
        },
      } = await store.dispatch(
        getScheme({
          url:
            window.location.href.replace(
              /(&linkType=wechat)|(linkType=wechat&)/g,
              ''
            ) + '&channel=wxopen',
        })
      );
      if (wechatAppLinkSwitch === 'Y') {
        openWithApp(openlink);
      } else {
        gointo();
      }
    } else {
      gointo();
    }

    function openWithApp(scheme_link) {
      // let toggel = 1;
      let onloadTimer = null;
      // 尝试打开 scheme
      window.location.href = scheme_link;
      // 设置15秒无操作，进入详情页
      onloadTimer = setTimeout(function() {
        // toggel = 0;
        gointo();
        clearTimeout(onloadTimer);
      }, 15000);

      // window.addEventListener('focus', function() {
      //   if (toggel === 1) {
      //     gointo();
      //     clearTimeout(onloadTimer);
      //   }
      // });
    }
    function gointo() {
      let wxchannel = '';
      if (
        window.__wxjs_environment &&
        window.__wxjs_environment === 'miniprogram'
      ) {
        wxchannel = '&channel=wxopen';
      }
      let isS_Num = nextState.location.query.orderNo.includes('S');
      let scene = isS_Num ? '100' : '101';
      const state = store.getState();
      let channel = JSON.parse(
        window.sessionStorage.getItem('emp_channel')
          ? window.sessionStorage.getItem('emp_channel')
          : null
      )
        ? JSON.parse(window.sessionStorage.getItem('emp_channel')).use_channel
        : '';
      if (
        !navigator.userAgent.toLowerCase().includes('toutiaomicroapp') &&
        channel !== 'YGZQ' &&
        state.App.lang.language !== 'en'
      ) {
        memberPopup({
          getMemberList: data => store.dispatch(getPassageMemberLevel(data)),
          crateNps: data => store.dispatch(searchNpsUrl(data)),
          query: nextState.location.query,
          fdbParmas: {
            businessId: scene,
            returnUrl: window.location.href.replace(
              /(&vipMember=Y)|(vipMember=Y&)/g,
              ''
            ),
            channel: userAgentType(),
            scene,
            routeType: window.localStorage.getItem('routeType'),
            changeNo: isS_Num ? nextState.location.query.orderNo : '',
            refundNo: isS_Num ? '' : nextState.location.query.orderNo,
          },
          lang: state.App.lang,
        });
      }
      gspNewVersion(
        orderType === 'S'
          ? ['变更详情页面', '072-0036-23028-12201']
          : ['退票详情页面', '072-0058-23028-12201'],
        {
          1: '页面曝光一次触发一次',
          2: '国双新版',
          3: isCsairApp() ? 'App' : 'Mobile',
        }
      );

      window.$sensors.sensors.track(
        'flight_ticket_refund_and_change_page_view',
        {
          page_name:
            orderType === 'S'
              ? '机票退改-变更详情页'
              : orderNo.includes('TJ')
              ? '机票退改-取消行程详情页'
              : '机票退改-退票详情页',
          channel_id: channel ? channel : '',
          refund_change_order_id: orderNo,
        }
      );

      if (session('emp-mobile') && session('emp-mobile').fromEmp) {
        window.sessionStorage.setItem(
          'emp-mobile',
          JSON.stringify({
            fromEmp: false,
          })
        );
        window.history.go(-1);
        return false;
      }
      if (
        state.App.oldLocation.pathname !== Routes.ticket.child.applySubmit.path
      ) {
        PopUpLoad('load', state.App.lang);
      }
      callback();
    }
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },

  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const ReformProcess = require('./components/SubInformation').default;
        cb(null, ReformProcess);
      },
      'reformProcess'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/reformProcess/index.js